import { useState } from 'react'
import { updateNode } from '../firebase/realtime.js'

export default function InstructorSettings({ activeRoom, roomConfig, onClose }) {
  // Quota is now a single per-room cap (any dance type counts the same).
  // Defaults: Main Room = 7, Room 2 = 2.
  const isLineOnly = activeRoom === 'late'
  const defaultLimit = isLineOnly ? 2 : 7
  const [requestLimit, setRequestLimit] = useState(
    roomConfig?.limits?.requests_per_user ?? defaultLimit,
  )
  const [accepting, setAccepting] = useState(roomConfig?.accepting_requests ?? true)
  const [saving, setSaving] = useState(false)

  async function save() {
    setSaving(true)
    try {
      await updateNode(`rooms/${activeRoom}`, {
        accepting_requests: accepting,
        limits: {
          requests_per_user: Number(requestLimit),
        },
      })
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm z-20 grid place-items-end sm:place-items-center"
      onClick={onClose}
    >
      <div
        className="bg-peak-surface w-full max-w-md p-5 rounded-t-3xl sm:rounded-3xl space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-baseline justify-between">
          <h2 className="font-bold text-lg">Settings — {roomConfig?.name || activeRoom}</h2>
          <button type="button" onClick={onClose} className="text-peak-muted text-sm">
            Close
          </button>
        </div>

        <p className="text-xs text-peak-muted">
          To open or close the entire night for both rooms, use the Begin / End-the-night
          control on the main screen. Settings here only affect this single room.
        </p>

        <label className="flex items-center justify-between">
          <span>Accepting requests for this room</span>
          <input
            type="checkbox"
            checked={accepting}
            onChange={(e) => setAccepting(e.target.checked)}
            className="h-5 w-5 accent-peak-accent"
          />
        </label>

        <label className="block">
          <span className="text-xs text-peak-muted">
            Max requests per dancer
            {isLineOnly
              ? ' (Room 2 — all requests are line dance)'
              : ' (Main Room — any mix of swing or line)'}
          </span>
          <input
            type="number"
            min="1"
            max="50"
            value={requestLimit}
            onChange={(e) => setRequestLimit(e.target.value)}
            className="w-full mt-1 px-3 py-2 rounded-xl bg-peak-bg border border-white/10"
          />
        </label>

        <p className="text-xs text-peak-muted">
          Votes are unlimited — dancers can heart any song, but only once each.
        </p>

        <button onClick={save} disabled={saving} className="btn-primary w-full">
          {saving ? 'Saving…' : 'Save'}
        </button>

        <p className="text-xs text-peak-muted text-center">
          The 2am cron also auto-wipes data nightly as a safety net.
        </p>
      </div>
    </div>
  )
}
